var map = {
	"./image0_suprise.jpg": 6392,
	"./image10_picasso.jpg": 7741,
	"./image11_vangogh.jpg": 8118,
	"./image12_subdued.jpg": 5290,
	"./image13_manga.jpg": 2363,
	"./image14_collage.jpg": 2364,
	"./image15_watercolor.jpg": 7476,
	"./image16_emoji.jpg": 2377,
	"./image1_oil.jpg": 4888,
	"./image2_cartoon.jpg": 5029,
	"./image3_realistic.jpg": 1612,
	"./image4_comic.jpg": 2808,
	"./image5_line.jpg": 6915,
	"./image6_abstract.jpg": 7681,
	"./image7_dreamlike.jpg": 4972,
	"./image8_vintage.jpg": 7222,
	"./image9_cyberpunk.jpg": 7722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2111;